import React from "react";
import {
    Box,
    Typography,
    Grid,
    Card,
    CardContent,
    CardActionArea,
    styled,
    keyframes
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import {FaCartShopping} from "react-icons/fa6";
import {BiSolidOffer} from "react-icons/bi";
import {TbMenuOrder} from "react-icons/tb";
import {Balance, Campaign, DomainVerification, ListOutlined} from "@mui/icons-material";
import {FaCartPlus, FaPlusCircle} from "react-icons/fa";
import {GoPin} from "react-icons/go";
import {PiFlagBanner} from "react-icons/pi";
import {MdDashboard, MdVerticalAlignTop} from "react-icons/md";
import {IoTicketOutline} from "react-icons/io5";
import {GrTransaction} from "react-icons/gr";
import {Can} from "../Can";
import {GiBuyCard} from "react-icons/gi";
import {SiTrustpilot} from "react-icons/si";

// Animation for card entrance
const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;

// Styled card component with hover effects
const OrderCard = styled(Card)(({ theme }) => ({
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    transition: 'transform 0.3s, box-shadow 0.3s',
    animation: `${fadeIn} 0.5s ease-out`,
    '&:hover': {
        transform: 'translateY(-5px)',
        boxShadow: theme.shadows[8],
    },
}));

const CardTitle = styled(Typography)({
    fontWeight: 600,
    position: 'relative',
    paddingBottom: '8px',
    '&:after': {
        content: '""',
        position: 'absolute',
        bottom: 0,
        left: '50%',
        transform: 'translateX(-50%)',
        width: '40px',
        height: '3px',
        backgroundColor: '#3f51b5',
    },
});

export const ManageOrdersTable = () => {
    const navigate = useNavigate();

    // Card data - replace with your actual content
    const orderCards = [
        { id: 1, title: "Our Orders Management", path: "/Orders",icon : ListOutlined,permission:'orders',action:'index' },
        { id: 2, title: "Add Order By Service", path: "/Add-Order-By-Service" ,icon :FaCartPlus,permission:'orders',action:'store' },
        { id: 3, title: "Add Order By Offer", path: "/Add-Order-By-Offer" ,icon :FaCartPlus,permission:'offerOrders',action:'store' },
        { id: 4, title: "Add Custom Offer", path: "/Add-Custom-Offer" ,icon :FaCartPlus,permission:'customOffer',action:'store' },
        { id: 5, title: "Add Balance Request", path: "/AddBalanceRequests",icon : Balance,permission:'addBalanceRequests',action:'index' },
        { id: 6, title: "Do Order Request", path: "/OrderRequests",icon : GiBuyCard,permission:'orderRequests',action:'index' },
        { id: 7, title: "Pins List", path: "/Ads-Pin" ,icon :GoPin,permission:'pins',action:'index' },
        { id: 8, title: "Main Page List", path: "/Ads-Main-Page" ,icon :PiFlagBanner,permission:'banners',action:'index' },
        { id: 9, title: "Search Result List", path: "/Ads-Search-Result" ,icon :MdVerticalAlignTop,permission:'topResults',action:'index' },
        { id: 10, title: "Ticket List", path: "/Ads-Ticket" ,icon :IoTicketOutline,permission:'ticketAds',action:'index' },
        { id: 11, title: "Trust List", path: "/Trust" ,icon :SiTrustpilot,permission:'trust',action:'index' },
        { id: 12, title: "Smmticket Campaings List", path: "/Smm-ticket-campaings" ,icon :Campaign,permission:'smmticket',action:'index' },
        { id: 13, title: "Transactions", path: "/Transaction" ,icon :GrTransaction ,permission:'transaction',action:'index'},
        { id: 14, title: "Smm Domain Requests", path: "/SmmDomainRequests" ,icon :DomainVerification ,permission:'smmDomain',action:'index'},
        { id: 15, title: "Update Order Requests", path: "/UpdatedOrders" ,icon :DomainVerification ,permission:'updatedOrders',action:'index'},
        { id: 16, title: "Reseller Report", path: "/resellers-statistics" ,icon :DomainVerification ,permission:'orders',action:'index'},
    ];

    const handleCardClick = (path: string) => {
        navigate(path);
    };

    return (
        <Box sx={{ flexGrow: 1, p: 3 }}>
            <Typography variant="h4" gutterBottom sx={{
                fontWeight: 700,
                mb: 4,
                textAlign: 'center',
                color: 'text.primary'
            }}>
                Manage Orders
            </Typography>

            <Grid container spacing={3}>
                {orderCards.map((card) => (
                    <Can I={card.action} a={card.permission}>
                    <Grid item xs={12} sm={6} md={4} key={card.id}>

                        <OrderCard>
                            <CardActionArea
                                onClick={() => handleCardClick(card.path)}
                                sx={{ height: '100%', p: 2 }}
                            >
                                <CardContent sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    textAlign: 'center'
                                }}>
                                    {/* Placeholder for icon - replace with your actual icon */}
                                    <Box sx={{
                                        width: 64,
                                        height: 64,
                                        bgcolor: 'primary.main',
                                        borderRadius: '50%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        mb: 2,
                                        color: 'white',
                                        fontSize: '1.5rem'
                                    }}>
                                        {card.icon ? <card.icon className="" /> : card.title.charAt(0)}
                                    </Box>

                                    <CardTitle variant="h6" gutterBottom>
                                        {card.title}
                                    </CardTitle>

                                    <Typography variant="body2" color="text.secondary">
                                        Click to access {card.title.toLowerCase()}
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </OrderCard>

                    </Grid>
                    </Can>
                ))}
            </Grid>
        </Box>
    );
};